const pageNameKey = "otaMachineHeader";

export const otaMachineHeaderEn = {
  [pageNameKey]: {
    currentFirmwareVersionText: "Latest Firmware Installed Over-The-Air",
    machineStatusAltText: "Machine Status",
  },
};

export const otaMachineHeaderPtBr = {
  [pageNameKey]: {
    currentFirmwareVersionText: "Versão de firmware instalada mais recente",
    machineStatusAltText: "Status da máquina",
  },
};

export const otaMachineHeaderDe = {
  [pageNameKey]: {
    currentFirmwareVersionText: "Neueste installierte Firmware-Version",
    machineStatusAltText: "Maschinenstatus",
  },
};

export const otaMachineHeaderZhHans = {
  [pageNameKey]: {
    currentFirmwareVersionText: "最新已安装固件版本",
    machineStatusAltText: "机器状态",
  },
};

export const otaMachineHeaderIt = {
  [pageNameKey]: {
    currentFirmwareVersionText: "Versione firmware installata più recente",
    machineStatusAltText: "Stato della macchina",
  },
};

export const otaMachineHeaderEs = {
  [pageNameKey]: {
    currentFirmwareVersionText: "Última versión de firmware instalada",
    machineStatusAltText: "Estado de la máquina",
  },
};

export const otaMachineHeaderNl = {
  [pageNameKey]: {
    currentFirmwareVersionText: "Laatst geïnstalleerde firmwareversie",
    machineStatusAltText: "Machinestatus",
  },
};

export const otaMachineHeaderTr = {
  [pageNameKey]: {
    currentFirmwareVersionText: "Kablosuz Olarak Yüklenen En Son Firmware",
    machineStatusAltText: "Makine Durumu",
  },
};
